import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { radius } from '@/styles/Themes/Metrics';
import { cssVars } from '@/styles/Themes/cssVars';
import Palette from '@/styles/Themes/Palette';
import { Transition } from '@/styles/Themes/KeyFrames';

export const CardContainer = styled.a`
    display: block;
    width: 100%;
    min-width: 240px;
    position: relative;
    flex-direction: column;
    border-radius: ${radius.small};
    background-color: ${cssVars.bg_white_dark3};
    ${Transition.normal};

    &:hover {
        box-shadow: ${cssVars.shadow_card_hover};
        ${Transition.normal};
    }
    ${Screen.ipad} {
        width: auto;
        flex: 1;
    }
    ${Screen.desktop} {
        width: calc(50% - 12px);
        flex: none;
    }
`;

export const ImgWrap = styled.div`
    height: 240px;
    position: relative;
    display: flex;
    border-radius: ${radius.small};
    overflow: hidden;

    ${Screen.ipad} {
        height: 300px;
    }
`;

export const Content = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: 14px;
`;

export const Title = styled.div`
    color: ${Palette.white.normal};
    ${Text.Mobile.large.semibold};
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    margin: auto 8px 12px;

    ${Screen.ipad} {
        ${Text.Full.large.semibold};
    }

    ${Screen.desktop} {
        max-width: 90%;
    }
`;

export const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const Bottom = styled.div``;

export const BottomLeft = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(13, 209, 197, 0.8);
    border-radius: 24px;
    color: ${Palette.white.normal};
    padding: 0 24px;
    height: 24px;
    ${Text.Full.medium.semibold}
`;

export const Gradient = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(
        180deg,
        rgba(12, 11, 11, 0) 31.6%,
        rgba(0, 0, 0, 0.416) 73.45%
    );
`;
